// This does not uses isUndefined method because it will throw an error in non-browser environments
export const globalObject = (typeof globalThis !== 'undefined'
    ? globalThis
    : typeof global !== 'undefined'
        ? global
        : typeof self !== 'undefined'
            ? self
            : undefined);
